import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=054a96b6&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/production-Q-saas-plat-manage-vue/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054a96b6"]])

export default __exports__